import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import CheckCircle from "@mui/icons-material/CheckCircle";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorageIcon from "@mui/icons-material/Storage";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import SecurityIcon from "@mui/icons-material/Security";
import HelpIcon from "@mui/icons-material/Help";
const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&:before": {
		display: "none",
	},
}));

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === "dark"
			? "rgba(255, 255, 255, .05)"
			: "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)",
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1),
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions() {

	const [panel1, setpanel1] = React.useState(true);
	const [panel2, setpanel2] = React.useState(true);
	const [panel3, setpanel3] = React.useState(true);
	const [panel4, setpanel4] = React.useState(true);
	const [panel5, setpanel5] = React.useState(true);
	const [panel6, setpanel6] = React.useState(true);
	const [panel7, setpanel7] = React.useState(true);
	const [panel8, setpanel8] = React.useState(true);

	
	return (
		<div className="camparision">
			<td className="hide" style={{ color: "#e1fffe" }}>
				<img src="/Images/support_background.svg" alt="" />
			</td>
			<div className="d-flex comparision-head">
				<td>
					<span>DAStart</span>
					<div>₹ 79/mo</div>
					<a
						class="btn btn-primary ctabtn "
						href="http://my.clubhosty.com/cart.php?a=add&pid=89&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
				<td>
					<span>DAProfessional</span>
					<div>₹ 109/mo</div>
					<a
						class="btn btn-primary ctabtn"
						href="http://my.clubhosty.com/cart.php?a=add&pid=90&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
				<td>
					<span>DAElite</span>
					<div>₹ 149/mo</div>
					<a
						class="btn btn-primary ctabtn"
						href="http://my.clubhosty.com/cart.php?a=add&pid=91&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
			</div>

			<Accordion
				expanded={panel1}
				onChange={() => {
					setpanel1(!panel1);
				}}
			>
				<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
					<Typography>
						<OpenWithIcon className="comp-title-icon" />
						Web Hosting Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Host Website</td>
									{/* <td>
										<CheckCircle color="success" />
									</td> */}
									<td>1</td>
									<td>10</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Free Domain</td>
									<td>NO</td>
									<td>NO</td>
									<td>.IN/.COM</td>
								</tr>
								<tr>
									<td>NVMe SSD Drive</td>
									<td>10GB NVMe</td>
									<td>50GB NVMe</td>
									<td>100GB NVMe</td>
								</tr>
								<tr>
									<td>Bandwidth</td>
									<td>Unmetered</td>
									<td>Unmetered</td>
									<td>Unmetered</td>
								</tr>
								<tr>
									<td>Control Panel</td>
									<td>DirectAdmin</td>
									<td>DirectAdmin</td>
									<td>DirectAdmin</td>
								</tr>
								<tr>
									<td>1-Click Installer</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr>
									<td>Free Drag and Drop Sitebuilder</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr>
									<td>Sub-Domains</td>
									<td>5</td>
									<td>20</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Parked Domains</td>
									<td>5</td>
									<td>10</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Addon Domains</td>
									<td>NO</td>
									<td>YES</td>
									<td>YES</td>
								</tr>
								<tr>
									<td>SSL Certificate</td>
									<td>LetsEncrypt</td>
									<td>LetsEncrypt</td>
									<td>LetsEncrypt</td>
								</tr>
								<tr>
									<td>Free Website Backup</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr>
									<td>FTP Users</td>
									<td>5</td>
									<td>10</td>
									<td>100</td>
								</tr>
								<tr>
									<td>Softaculous Installer</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel2}
				onChange={() => {
					setpanel2(!panel2);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<Inventory2Icon className="comp-title-icon" />
						Control Panel Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>FTP Account Management</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Virus Scanner</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Apache Handlers Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Hotlink Protection</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>IP Deny Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Index Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>MIME Types Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Redirect Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Change Language</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Web Disk</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Password Protection</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Multiple PHP Support</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Customizable php.ini</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Cron Jobs</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Manage DNS</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Install PHP PEAR Packages</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Install Perl Modules</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Backup Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Git Version Control</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Resource Usage Monitoring</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>User Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Style and Preferences Management</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>File Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Cache Manager</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Custom Error Pages</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel3}
				onChange={() => {
					setpanel3(!panel3);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<StorageIcon className="comp-title-icon" /> Server Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Apache with LiteSpeed</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>HTTP/2</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>PHP 7.4 to 8.2</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>SSH</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>WAF Protection</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Database Optimizer</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Lossless Data Compression</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Browser Optimization</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Memcached</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>OPCache</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Mod_Expires</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Laravel</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>CodeIgnitor</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Leverage Browser Caching</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Gzip Compression</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Expires Headers</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>KeepAlive</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>WP-CLI</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>1-Click Installer</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel4}
				onChange={() => {
					setpanel4(!panel4);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<i class="fa fa-database comp-title-icon"></i>Databases Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>MySQL Databases</td>
									<td>2</td>
									<td>15</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>MySQL DB Size</td>
									<td>1000MB / Database</td>
									<td>1000MB / Database</td>
									<td>1000MB / Database</td>
								</tr>
								<tr>
									<td>PHP MyAdmin</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Remote MySQL</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel5}
				onChange={() => {
					setpanel5(!panel5);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<LocalPostOfficeIcon className="comp-title-icon" />
						Email Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Email Accounts</td>
									<td>2</td>
									<td>15</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Email Forwarders</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Email Autoresponders</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Attachment Limit</td>
									<td>100 MB</td>
									<td>100 MB</td>
									<td>100 MB</td>
								</tr>
								<tr>
									<td>RoundCube Webmail</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>SMTP, POP3, IMAP</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>SPF and DKIM Support</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Individual Mailbox Storage</td>
									<td>5GB</td>
									<td>5GB</td>
									<td>5GB</td>
								</tr>
								<tr>
									<td>Overall Mailbox Storage</td>
									<td>10GB</td>
									<td>10GB</td>
									<td>10GB</td>
								</tr>
								<tr>
									<td>Email Sends Per Hour</td>
									<td>25</td>
									<td>50</td>
									<td>100</td>
								</tr>
								<tr>
									<td>Webmail in Gmail</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Outlook / Thunderbird / Mac Mail</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel6}
				onChange={() => {
					setpanel6(!panel6);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<SecurityIcon className="comp-title-icon" />
						Security Solutions
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Network Firewall</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Web Application Firewall</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Brute-force Protection</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Exploits and Malware Protect</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Malware Scan and Reports</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Two-Factor Authentication (2FA)</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Monarx Server Security</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Account Isolation</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Power / Network / Hardware Redundancy</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel7}
				onChange={() => {
					setpanel7(!panel7);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<i class="fa fa-code comp-title-icon"></i>Account Resources
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>CPU Core</td>
									<td>7</td>
									<td>7</td>
									<td>7</td>
								</tr>
								<tr>
									<td>RAM</td>
									<td>5GB</td>
									<td>5GB</td>
									<td>5GB</td>
								</tr>
								<tr>
									<td>Concurrent connections (EP)</td>
									<td>30</td>
									<td>30</td>
									<td>30</td>
								</tr>
								<tr>
									<td>Number of processes (nPROC)</td>
									<td>100</td>
									<td>100</td>
									<td>100</td>
								</tr>
								<tr>
									<td>IO Limit</td>
									<td>10MBPS</td>
									<td>10MBPS</td>
									<td>10MBPS</td>
								</tr>
								<tr>
									<td>File (Inode) Limit</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel8}
				onChange={() => {
					setpanel8(!panel8);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<HelpIcon className="comp-title-icon" />
						Our Guarantees
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>30 Day Money Back Guarantee</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>99.95% Uptime Guarantee</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Upgrade on Pro Rata Basis</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>24/7/365 Expert Support</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Free Website Migration</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								<tr>
									<td>Instant Setup</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
									<td>
										<CheckCircle color="success" />
									</td>
								</tr>
								{/* <tr>
									<td>Free Video Tutorials</td>
									<td>1</td>
									<td>10</td>
									<td>Unlimited</td>
								</tr> */}
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>
		</div>
	);
}
